import { render } from "./itemPrices.vue?vue&type=template&id=0c09ee5b&scoped=true"
import script from "./itemPrices.vue?vue&type=script&lang=js"
export * from "./itemPrices.vue?vue&type=script&lang=js"

import "./itemPrices.vue?vue&type=style&index=0&id=0c09ee5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c09ee5b"]])

export default __exports__